<div *ngIf="loading" class="banner-loading vw-100">
  <div class="banner-skeleton vw-100"></div>
</div>

<div *ngIf="!loading && slides.length > 0" class="banner-carousel pos-re vw-100">
  <p-carousel
    #carousel
    [value]="slides"
    [numVisible]="1"
    [numScroll]="1"
    [circular]="slides.length > 1"
    [appBannerAutoplay]="slides"
    [showNavigators]="false"
    [showIndicators]="false"
    styleClass="banner-carousel-shared"
    (onPage)="onPageChange($event)"
  >
    <ng-template let-banner pTemplate="item">
      <div class="banner-slide pos-re vw-100">
        <img
          class="banner-image vw-100 d-block"
          [src]="banner.imageUrl"
          [alt]="banner.title || 'banner'"
          (error)="onImageError(banner)"
        />
      </div>
    </ng-template>
  </p-carousel>

  <div *ngIf="slides.length > 1" class="banner-navigation pos-ab d-flex jc-sb ai-center">
    <button type="button" class="banner-nav-button d-flex ai-center jc-center cursor-pointer" (click)="prev()">
      <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
    <button type="button" class="banner-nav-button d-flex ai-center jc-center cursor-pointer" (click)="next()">
      <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
  </div>

  <div *ngIf="slides.length > 1" class="banner-indicators pos-ab d-flex ai-center">
    <button
      *ngFor="let banner of slides; let i = index"
      type="button"
      class="banner-indicator cursor-pointer p-0 m-0"
      [class.is-active]="currentIndex === i"
      (click)="goTo(i)"
    ></button>
  </div>
</div>
